// src/App.js
import React from "react";
import "flag-icon-css/css/flag-icons.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import BookTablePage from "./pages/BookTablePage";
import PrivateEventsPage from "./pages/PrivateEventsPage";
import OrderPage from "./pages/OrderPage";
import ContactPage from "./pages/ContactPage";
import BuffetBookingPage from "./pages/BuffetBookingPage";
import ThankYouPage from "./pages/ThankYouPage";
import OrderTracking from "./pages/OrderTracking";
import ScrollToTop from "./components/ScrollToTop";
import { CartProvider } from "./context/CartContext";
import { UserProvider } from "./context/UserContext";
import { CheckoutProvider } from "./context/CheckoutContext";
// import CheckoutModalWrapper from "./components/CheckoutModalWrapper";

import PaymentSuccess from "./pages/PaymentSuccess";
import LasgidiGotTalent from "./pages/LasgidiGotTalent";
import WelcomePopup from "./components/WelcomePopup";
// import LoyaltyPopup from "./components/LoyaltyPopup";
import Checkout from "./pages/Checkout";
import Profile from "./pages/ProfilePage";

function App() {
  return (
    <UserProvider>
        <CheckoutProvider>
          <CartProvider>
            <Router>
              <ScrollToTop />
                <WelcomePopup />
                {/* <LoyaltyPopup /> */}
              <Navbar />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/book-table" element={<BookTablePage />} />
                <Route path="/private-events" element={<PrivateEventsPage />} />
                <Route path="/order-online" element={<OrderPage />} />
                <Route path="/buffet" element={<BuffetBookingPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/thank-you" element={<ThankYouPage />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/lasgidi-got-talent" element={<LasgidiGotTalent />} />
                <Route path="/order-tracking" element={<OrderTracking />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/profile" element={<Profile />} />
              </Routes>
              <Footer />
              {/* <CheckoutModalWrapper /> */}
            </Router>
          </CartProvider>
        </CheckoutProvider>
    </UserProvider>
  );
}

export default App;
